module.exports = __webpack_public_path__ + "static/ms2-pattern-examples-774ba25fdc48633bf366b8a6cce1d8fd.svg";